import React from 'react';
import { FaqItem } from '../FaqItem';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../../data/content';
export function FaqSection() {
  return <section aria-labelledby="faq-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-73" data-mp="2kxfiqho1rgor">
      <div className="mx-auto max-w-3xl" data-id="element-74" data-mp="2fyccitwbz4f7">
        <SectionHeading id="faq-heading" title="Frequently Asked Questions" data-id="element-75" data-mp="2fxaz4irue5ub" />
        <div className="mt-10 border-t border-brand-charcoal/12" data-id="element-76" data-mp="2txlqro0z7ogj">
          {faqs.map(faq => <FaqItem key={faq.question} {...faq} data-id="element-77" data-mp="2px1yoyv9fb19" />)}
        </div>
      </div>
    </section>;
}